import { ListenableSubscribable } from '@benzinga/subscribable';
import { deepEqual } from '@benzinga/utils';
import { PriceAlerts } from './proto/price_alerts_protos';

interface PriceAlertsUpdatedEvent {
  categoriesAlerts: Partial<PriceAlerts.Alert>[];
  type: 'price_alerts_updated';
}

export type PriceAlertsStoreEvent = PriceAlertsUpdatedEvent;

export class PriceAlertsStore extends ListenableSubscribable<PriceAlertsStoreEvent> {
  private date?: Date;
  private priceAlerts?: Partial<PriceAlerts.Alert>[];

  public shouldWeFetchAlerts = (): boolean => {
    const ONE_MIN = 60 * 1000; /* ms */
    const lastCalled = this.date?.getTime() ?? 0; // use this once all watchlist are grabbed from manager
    if (this.priceAlerts === undefined || Date.now() - lastCalled > ONE_MIN) {
      return true;
    }
    return false;
  };

  public getPriceAlerts = (): Partial<PriceAlerts.Alert>[] | undefined => {
    return this.priceAlerts;
  };

  public setPriceAlerts = (priceAlerts: Partial<PriceAlerts.Alert>[]): void => {
    this.date = new Date();
    if (deepEqual(this.priceAlerts, priceAlerts) === false) {
      this.priceAlerts = priceAlerts;
      this.dispatch({
        categoriesAlerts: priceAlerts,
        type: 'price_alerts_updated',
      });
    }
  };
}
